//用户信息

export default {
  //namespaced 开启namespaced
  namespaced: true,
  //action 响应组件动作 逻辑写在这
  actions: {

  },
  //mutation 处理数据 不要写逻辑
  mutations: {

  },
  //state 数据/状态
  state: {
    //业务类型参数
    approveParam: {
      allApprove:0,//全部数据
      visitReport: 1,//访问报告
      customer: 2,//客户
      invalidReport:-1,//过期访问报告
    },
    //外出打卡记录类型 
    SignCheckType:{
      personal:0,//个人打卡记录
      branch:1,//部门打卡记录
    },
    //角色
    RoleType:{
      admin:'Admin',
      manager:'Manager',
      salesman:'Salesman',
      mutiBranch : '跨部门管理',
      salesCoordinator:'销售助理',
    },
    //线索类型
    clueParam:{
      allClue:'',
      close:'Close',//关闭
      ing:'Ing',//跟进中
      na:'NA',//未联系
      trans:'Trans'//转销售
    }
  },
  //getters 用于state后续数据加工
  getters: {

  },
}